import React, { useState } from 'react';

import { Box } from '@mui/material';

import HeroBanner from '../components/HeroBanner';
import SearcExercises from '../components/SearcExercises';
import Exercises from '../components/Exercises';

const Home = () => {
  const [bodyPart, setBodyPart] = useState('all')
  const [exercises, setExercises] = useState([]);
  console.log(bodyPart);

  return (
    <Box>
      <HeroBanner />
      <SearcExercises 
        setExercises={setExercises}
        setBodyPart={setBodyPart}
        bodyPart={bodyPart}
      />
      <Exercises 
         setExercises={setExercises}
         exercises={exercises}
         bodyPart={bodyPart}
      />
    </Box>
  )
}

export default Home;